
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32","width":"16","height":"16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.77 4.012c-.239.015-.48.066-.72.144l-2 .664A3.012 3.012 0 009 7.668v3.289l-4 .563v14.96L23 29l4-1.32V10.438L23 9l-2 .281V8c0-1.512-1.145-2.715-2.523-2.953a2.93 2.93 0 00-1.426.11l-.57.19a3.086 3.086 0 00-2.004-1.3c-.23-.04-.465-.05-.707-.035zM13.934 6C14.508 5.945 15 6.379 15 7v3.121l-4 .559V7.668c0-.434.27-.809.684-.95l2-.663a.993.993 0 01.25-.055zm4 1C18.508 6.95 19 7.379 19 8v1.563l-2 .277V7.28l.684-.226a.993.993 0 01.25-.055zm4.851 4.047l2.215.797v14.39l-2.184.72L7 24.737V13.262zM19 13.597l-5 .704V18h5zm-6 .84L9 15v3h4zM9 19v3l4 .563V19zm5 0v3.7l5 .702V19z"}})])
          )
        }
      }
    